const FAVORITES = {
  LOCAL_STORAGE_KEY: "FairFinder.favorites",

  get: () => {
    let storeIds = localStorage.getItem(FAVORITES.LOCAL_STORAGE_KEY);
    if (storeIds === null) return [];
    else return JSON.parse(storeIds);
  },

  add: storeId => {
    let favs = FAVORITES.get();
    favs.push(storeId);
    localStorage.setItem(FAVORITES.LOCAL_STORAGE_KEY, JSON.stringify(favs));
    return favs;
  },

  remove: storeId => {
    let favs = FAVORITES.get();
    for (let i = 0; i < favs.length; i++) {
      if (favs[i] === storeId) {
        favs.splice(i, 1);
        break;
      }
    }
    localStorage.setItem(FAVORITES.LOCAL_STORAGE_KEY, JSON.stringify(favs));
    return favs;
  }
};

export default FAVORITES;
